export enum RouteDataKey {
  Details,
}
